export default class Search {
    constructor(elm, args) {
        const searchMenu = document.querySelector('.search-menu');
        const searchField = elm.querySelector('[data-search-field]');
        const allSearchResults = searchMenu.querySelectorAll('[data-search-results]');
        const categories = searchMenu.querySelectorAll('[data-category]');
        const loadMore = searchMenu.querySelectorAll('[data-load-more]');
        const underline = searchMenu.querySelector('.search-menu__banner__underline');
        const closeSearchButtons = document.querySelectorAll('[data-close-search]');
        const header = searchMenu.closest('header');
        const body = document.body;
        const defaultCategory = searchMenu.querySelector('[data-default]');
        const openSearchButton = document.querySelectorAll('[data-open-search]');
        const scrollSearchButton = document.querySelector('[data-scroll-search-button]');
        const desktop = window.matchMedia('(min-width:992px)');

        openSearchButton.forEach(x => x.onclick = e => {
            const closeButton = e.target.closest('[data-close-search]');
            if (!closeButton) {
                openSearch();
            }
        });

        searchMenu.querySelectorAll('[data-toggle]').forEach(x => x.onclick = () => {
            searchMenu.dataset.active = x.dataset.toggle;
        });

        categories.forEach(x => x.onclick = () => {
            if (x.classList.contains('search-menu__banner__category--inactive')) { return; }

            selectCategory(x);
        });

        searchField.addEventListener('input', updateSearch);
        searchField.addEventListener('change', updateSearch);

        window.onkeydown = function (event) {
            if (event.keyCode == 27) {
                closeSearch();
            }
        };

        closeSearchButtons.forEach(x => x.onclick = closeSearch);

        loadMore.forEach(x => x.onclick = () => {
            if (searchField.value.length > 2) {
                const categoryElem = searchMenu.querySelector(`[data-category="${x.dataset.loadMore}"]`);
                categoryElem.page++;
                fetch(`/umbraco/surface/search/SearchInCategory?query=${searchField.value}&page=${categoryElem.page}&category=${x.dataset.loadMore}`)
                    .then(x => x.json()).then(json => {
                        const searchResults = searchMenu.querySelector(`[data-search-results="${json.Category}"]`);
                        const categoryElem = searchMenu.querySelector(`[data-category="${json.Category}"]`);
                        searchResults.innerHTML += json.ItemsHtml;
                        updateCategory(json, categoryElem);
                    });
            }
        });

        scrollSearchButton.addEventListener('click', searchInScrollClicked);

        function searchInScrollClicked() {
            header.classList.remove('nav-down');
            header.classList.remove('nav-up');

            setTimeout(() => {
                openSearch();
            }, 300);
        }

        function selectCategory(category) {
            searchMenu.querySelectorAll('.search-menu__banner__category--selected')
                .forEach(y => y.classList.remove('search-menu__banner__category--selected'));

            category.classList.add('search-menu__banner__category--selected');
            searchMenu.dataset.filter = category.dataset.category;
            if (desktop.matches) {
                underline.style.transform = `translateX(${category.offsetLeft}px)`;
                underline.style.width = `${category.getBoundingClientRect().width}px`;
            } else {
                underline.style.transform = `translateY(${category.offsetTop}px)`;
                underline.style.height = `${category.getBoundingClientRect().height}px`;
            }
        }

        let lastSearch = '';

        function updateSearch() {
            if (searchField.value.length > 2) {
                if (lastSearch != searchField.value) {
                    searchMenu.classList.add('search-loading');
                    clearSearch();
                    lastSearch = searchField.value;
                    const curSearch = searchField.value;
                    const csrfToken = document.querySelector('input[name="__RequestVerificationToken"]').value;
                    setTimeout(() => {
                        fetch('/umbraco/surface/search/search', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'RequestVerificationToken': csrfToken,
                            },
                            body: JSON.stringify({
                                query: searchField.value,
                                page: 1,
                                pageSize: 12,
                            }),
                        })
                            .then(x => x.json()).then(json => {
                                if (curSearch == lastSearch) {
                                    json.Categories.forEach(category => {
                                        const searchResults = searchMenu.querySelector(`[data-search-results="${category.Category}"]`);
                                        const categoryElem = searchMenu.querySelector(`[data-category="${category.Category}"]`);
                                        categoryElem.page = 1;
                                        updateCategory(category, categoryElem, true);
                                        searchResults.innerHTML = category.ItemsHtml;
                                    });

                                    categories.forEach(category => {
                                        category.classList.remove('search-menu__banner__category--selected');
                                    });
                                    const defaultCategoryJson = json.Categories.filter(x => x.Category == defaultCategory.dataset.category)[0];
                                    if (defaultCategory && defaultCategoryJson.TotalAmount != 0) {
                                        selectCategory(defaultCategory);
                                    } else {
                                        const nextCategory = json.Categories.find(x => x.TotalAmount > 0);
                                        if (nextCategory && nextCategory.TotalAmount > 0) {
                                            selectCategory(categories[3]);
                                        } else {
                                            selectCategory(categories[0]);
                                        }
                                    }

                                    searchMenu.classList.remove('search-loading');
                                    searchMenu.classList.add('searched');
                                    expandSection(searchMenu);
                                }
                            });
                    }, 1);
                }
            } else {
                clearSearch();
            }
        }

        function collapseSection(element) {

            // get the height of the element's inner content, regardless of its actual size
            const sectionHeight = element.scrollHeight;

            // temporarily disable all css transitions
            const elementTransition = element.style.transition;
            element.style.transition = '';
            element.classList.remove('search-menu--transitioned');

            // on the next frame (as soon as the previous style change has taken effect),
            // explicitly set the element's height to its current pixel height, so we
            // aren't transitioning out of 'auto'
            requestAnimationFrame(function () {
                element.style.height = sectionHeight + 'px';
                element.style.transition = elementTransition;

                // on the next frame (as soon as the previous style change has taken effect),
                // have the element transition to height: 0
                requestAnimationFrame(function () {
                    element.style.height = 0 + 'px';
                });
            });
        }

        function expandSection(element) {
            // get the height of the element's inner content, regardless of its actual size
            const sectionHeight = element.scrollHeight;

            // have the element transition to the height of its inner content
            element.style.height = sectionHeight + 'px';

            // when the next css transition finishes (which should be the one we just triggered)
            const endTransition = () => {
                element.removeEventListener('transitionend', endTransition);
                element.style.height = '';
                element.classList.add('search-menu--transitioned');

                if (!element.closest('.search-menu-open')) {
                    element.style.height = '';
                } else {
                    element.style.height = 'auto';
                }
            };

            element.addEventListener('transitionend', endTransition);
        }

        function updateHeight(element) {

        }

        function closeSearch() {
            // searchMenu.style.height = '0';
            collapseSection(searchMenu);
            body.classList.remove('search-menu-open');

        //    setTimeout(() => {
        //        body.classList.remove('search-menu-open')
        //    }, 500);
        }

        function openSearch() {
            body.classList.add('search-menu-open');
            expandSection(searchMenu);
            // setTimeout(() => {
            //    //searchMenu.style.maxHeight = '10000px';
            // }, 1);
            searchField.focus();
        }

        function clearSearch() {
            lastSearch = '';
            searchMenu.classList.remove('searched');
            allSearchResults.forEach(x => x.innerHTML = '');
            searchMenu.dataset.filter = '';
            categories.forEach(category => {
                category.querySelector('[data-category-amount]').innerHTML = 0;
                category.classList.add('search-menu__banner__category--inactive');
                category.classList.remove('search-menu__banner__category--selected');
            });
        }

        function updateCategory(category, categoryElem, reset = false) {
            const loadMoreButtom = searchMenu.querySelector(`[data-load-more="${category.Category}"]`);
            loadMoreButtom.classList.toggle('search-menu__load-more--disabled', category.CurrentPage >= category.TotalPages || category.TotalPages == 0);

            if (reset) {
                categoryElem.querySelector('[data-category-amount]').innerHTML = category.TotalAmount;
            }

            categoryElem.classList.toggle('search-menu__banner__category--inactive', category.TotalAmount == 0);
        }
    }
}
